import React from 'react';
import './index.css';
import App from './App';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ManagePage from './manage';
import { MantineProvider } from '@mantine/core';
import { ThemeProvider } from '@mui/material/styles'; // Import ThemeProvider
import './i18n/i18n'; // Import the i18n configuration
import { createTheme } from '@mui/material/styles';

// Create the custom theme
const theme = createTheme({
    typography: {
        fontFamily: "'Roboto', 'Hiragino Sans', 'Yu Gothic UI', 'Hiragino Kaku Gothic ProN', sans-serif",
    },
    root: {
        fontFamily: "'Roboto', 'Hiragino Sans', 'Yu Gothic UI', 'Hiragino Kaku Gothic ProN', sans-serif"
    }
});

// Clear the existing HTML content
document.body.innerHTML = '<div id="app"></div>';

// Render your React component instead
const root = createRoot(document.getElementById('app'));
root.render(
    <ThemeProvider theme={theme}> {/* Apply the custom theme */}
        <MantineProvider>
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<App />} />
                    <Route path="/manage" element={<ManagePage />} />
                </Routes>
            </BrowserRouter>
        </MantineProvider>
    </ThemeProvider>
);